import type { Sequence } from "../types/Sequence"
import { Reduce } from "./Reduce"

function* gen<T>(seq: Sequence<T>) {
  yield* seq
}

export function* Zip<T extends Sequence<unknown>[]>(
  ...args: T
): Iterable<{ [K in keyof T]: T[K] extends Sequence<infer U> ? U : never }> {
  if (args.length === 0) return

  // Convert all sequences to iterators
  const iterators = args.map(gen)

  while (true) {
    const results = iterators.map(iter => iter.next())

    // Stop if any iterator is done
    const done = Reduce(
      (acc, result) => acc || result.done || false,
      results,
      false
    )

    if (done) break

    yield results.map(result => result.value) as any
  }
}
